var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"form-element-switch-demo"}},[_c('switch-state'),_c('switch-color'),_c('switch-text'),_c('switch-icons'),_c('switch-array-value'),_c('switch-api')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }